Vendd.Scripts.load(function () {

	function init(context) {
		var $context = $(context);
		var $wrapper = $('.x-warehouse-selector-popup-step-two', $context);

		if ($wrapper.length < 1) {
			return;
		}

		var wrapper = $wrapper.get(0),
			$root,
			$formDelivery,
			$formFromStore,
			$store,
			$submitDeliveryButton,
			$submitFromStoreButton;

		var state = {
			supportsDelivery: undefined,
			supportsFromStore: undefined,
			store: undefined
		};

		wrapper.init = function () {
			$root = $('.warehouse-selector-popup-step-two', $wrapper);
			$formDelivery = $('.js-form-delivery', $root);
			$formFromStore = $('.js-form-fromstore', $root);
			$store = $(':input[name="store"]', $root);
			$submitDeliveryButton = $('.js-submit-delivery', $root);
			$submitFromStoreButton = $('.js-submit-fromstore', $root);

			state.supportsDelivery = $root.data('supports-delivery') === 'true';
			state.supportsFromStore = $root.data('supports-fromstore') === 'true';
			state.store = $store.selectedVal() || '';

			wrapper.updateViewState();
		};

		wrapper.updateViewState = function () {
			$formDelivery.toggleClass('js-active', state.supportsDelivery);
			$formFromStore.toggleClass('js-active', state.supportsFromStore);
			$submitDeliveryButton.toggleDisabled(!state.supportsDelivery);
			$submitFromStoreButton.toggleDisabled(!state.supportsFromStore || state.store === '');
		};

		wrapper.update = function (model) {
			//console.log('[WarehouseSelector] Selected store: ' + state.store);
			//console.log('[WarehouseSelector] Stores JSON model: ' + JSON.stringify(model));
			var html = Vendd.Handlebars.parse("warehouseSelectorStoreSelector_A", model.Stores);
			var $selector = $('.x-warehouse-selector-store-selector', $root).html(html);
			var $stores = $(':input[name="store"]', $selector);
			$stores.selectedVal(state.store);
			$root.data('supports-delivery', model.IsDeliveryShippingMethodSupported ? 'true' : 'false');
			$root.data('supports-fromstore', model.IsFromStoreShippingMethodSupported ? 'true' : 'false');
			wrapper.init();
		};

		wrapper.loading = function (status) {
			if (status === undefined) {
				return $wrapper.hasClass('x-loading');
			} else {
				$wrapper.toggleClass('x-loading', status);
			}
		};

		wrapper.updateStore = function (value) {
			if (state.store !== value) {
				console.log('[WarehouseSelector] Store: "' + state.store + '" -> "' + value + '"');
				state.store = value;
				wrapper.updateViewState();
			}
		};

		$wrapper.on('click', '.js-submit-delivery', function (e) {
			e.preventDefault();
			wrapper.loading(true);
			Vendd.MessageBus.publish(wrapper, new Vendd.WarehouseSelector.Messages.SetDeliveryShippingMethod());
		});

		$wrapper.on('click', '.js-submit-fromstore', function (e) {
			e.preventDefault();
			wrapper.loading(true);
			Vendd.MessageBus.publish(wrapper, new Vendd.WarehouseSelector.Messages.SetFromStoreShippingMethod(
				state.store
			));
		});

		$wrapper.on('change', ':input[name="store"]', function (e) {
			wrapper.updateStore($store.selectedVal());
		});

		Vendd.MessageBus.subscribe(Vendd.WarehouseSelector.Messages.GetStoresSuccess, wrapper, function (envelope) {
			wrapper.update(envelope.message.data.data);
		});

		Vendd.MessageBus.subscribe(Vendd.WarehouseSelector.Messages.SetShippingMethodSuccess, wrapper, function (envelope) {
			wrapper.loading(false);
		});

		Vendd.MessageBus.subscribe(Vendd.WarehouseSelector.Messages.SetShippingMethodFailed, wrapper, function (envelope) {
			wrapper.loading(false); /* TODO: Handle error. */
		});

		wrapper.init();
	}

	Vendd.MessageBus.subscribe(Vendd.Widget.Messages.BindControl, 'x-warehouse-selector-popup-step-two', function (envelope) {
		if (envelope.message.data.context === 'x-warehouse-selector-popup') {
			init(envelope.sender);
		}
	});
});
